import { useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getAllCourse } from '../../api/axios';
import CourseCard from '../../components/CourseCard';
import { useUser } from '../../context/userContext';
// import courses from '../../static/data/CourseData.json' // Use courses to display fake data. Change the neccesary fields (Line 29, 44, 56, 101)
import { Container, IconButton} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import LinearProgressBar from '../../components/LinearProgressBar';
import CourseInformation from '../../components/CourseInformation';
import { CookingPot } from '../../components/CookingSoon';

const MAX_COURSE_VISIBLE = 6

const CourseOverview = () => {
    const [courseData, setCourseData] = useState([])
    const [courseInProgress, setCourseInProgress] = useState([])
    const [startIndex, setStartIndex] = useState(0)
    const [startIndexProgress, setStartIndexProgress] = useState(0)
    const [selectedCourse, setSelectedCourse] = useState({})
    const {user}=useUser();
    
    useEffect(() => {
        console.log("coursesUser:",user);
        const fetchAllCourses = async () => {
            let inProgress = []
            try {
                const response = await getAllCourse();
                setCourseData(response.data)
                courseData.forEach(obj => {
                    if (obj.status === "In-Progress") {
                        inProgress.push(obj)
                    }
                });
                setSelectedCourse(response.data[0])
                setCourseInProgress(inProgress)
                console.log(response.data)
            } catch (error) {
                console.error(`Error fetching all courses: ${error}`)
            }
        };
        fetchAllCourses()
    }, []);

    const handleNextAll = () => {
        if (startIndex + MAX_COURSE_VISIBLE < courseData.length) {
            setStartIndex(startIndex + MAX_COURSE_VISIBLE)
        }
    }

    const handlePrevAll = () => {
        if (startIndex - MAX_COURSE_VISIBLE >= 0) {
            setStartIndex(startIndex - MAX_COURSE_VISIBLE)
        }
    }

    const handleNextProgress = () => {
        if (startIndexProgress + MAX_COURSE_VISIBLE < courseInProgress.length) {
            setStartIndexProgress(startIndexProgress + MAX_COURSE_VISIBLE)
        }
    }

    const handlePrevProgress = () => {
        if (startIndexProgress - MAX_COURSE_VISIBLE >= 0) {
            setStartIndexProgress(startIndexProgress - MAX_COURSE_VISIBLE)
        }
    }

    const handleChildClick = (data) => {
        setSelectedCourse(data)
    }

    return (
        <Box sx={{
            height: '100%',
            width: '100%',
            paddingLeft: '5%',
            paddingTop: '5%',
            display: "flex"
        }}>
            <Container>
                <Box sx={{display:'flex', justifyContent: 'space-between'}}>
                    <Typography sx={{fontSize: '22px', color: '#E1E1E6', fontWeight: 'bold'}}>
                            All Courses
                    </Typography>
                    <Box sx={{}}>
                        <IconButton onClick={handlePrevAll} disabled={startIndex === 0}
                        sx={{
                            color: '#E1E1E6'
                        }}>
                            <ArrowBackIosNewIcon sx={{fontSize: 'large'}}/>
                        </IconButton>
                        <IconButton onClick={handleNextAll} disabled={startIndex + MAX_COURSE_VISIBLE >= courseData.length}
                        sx={{
                            color: '#E1E1E6'
                        }}>    
                            <ArrowForwardIosIcon sx={{fontSize: 'large'}}/>
                        </IconButton>
                    </Box>
                </Box>
                <Box sx={{
                    display:'grid', 
                    gridTemplateColumns:'repeat(3, 1fr)', 
                    gridTemplateRows:'repeat(2, auto)', 
                    gap: 2
                }}>
                    {courseData.slice(startIndex, startIndex + MAX_COURSE_VISIBLE).map((course, index) => { 
                        return (
                            <Box>
                                <CourseCard key={index} onCourseClick={handleChildClick} course={course}/>
                                {/* <LinearProgressBar value={50}/> TODO: Change value dynamically */}
                            </Box>
                        )
                    })}
                </Box>
                <Box sx={{display:'flex', justifyContent:'space-between', paddingTop: '30px'}}>
                    <Typography sx={{fontSize: '22px', color: '#E1E1E6', fontWeight: 'bold'}}>
                        In Progress
                    </Typography>
                    <Box sx={{}}>
                        <IconButton onClick={handlePrevProgress} disabled={startIndexProgress === 0}
                        sx={{
                            color: '#E1E1E6'
                        }}>
                            <ArrowBackIosNewIcon sx={{fontSize: 'large'}}/>
                        </IconButton>
                        <IconButton onClick={handleNextProgress} disabled={startIndexProgress + MAX_COURSE_VISIBLE >= courseInProgress.length}
                        sx={{
                            color: '#E1E1E6'
                        }}>    
                            <ArrowForwardIosIcon sx={{fontSize: 'large'}}/>
                        </IconButton>
                    </Box>
                </Box>
                {/* <Box sx={{
                    display:'grid', 
                    gridTemplateColumns:'repeat(3, 1fr)', 
                    gridTemplateRows:'repeat(2, auto)', 
                    gap: 2
                }}>
                    {courseInProgress.slice(startIndexProgress, startIndexProgress + MAX_COURSE_VISIBLE).map((course, index) => { 
                        return (
                            <Box>
                                <CourseCard key={index} onCourseClick={handleChildClick} course={course}/>
                                {/* <LinearProgressBar value={50}/> TODO: Change value dynamically }
                            </Box>
                        )
                    })}
                </Box> */}
                <br/>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    paddingTop: '30px',
                    width: '100%',
                    justifyContent: 'center', // Center horizontally
                    alignItems: 'center',     // Center vertically
                    gap: 2
                }}>
                    <CookingPot/>
                    <Typography sx={{fontSize: '20x', color: '#E1E1E6', fontWeight: 'medium', textAlign: 'center'}}>Get to cooking! 👨‍🍳<br/>Click the courses above 👆</Typography>
                </Box>
            </Container>
            
            <Container>
                <Box sx={{
                    width: '70%',
                    background: 'linear-gradient(142.38deg, #6B3A8F -1.88%, #6DB8BF 196.69%)',
                    borderTopRightRadius: '35px',
                    borderBottomLeftRadius: '35px',
                    textAlign: 'center'
                }}>
                    <Typography sx={{fontSize: '22px', color: '#E1E1E6', fontWeight: 'bold'}}>
                        {selectedCourse.name}
                    </Typography>
                </Box>
                <Box sx={{
                    height: '90%'
                }}>
                    <CourseInformation course={selectedCourse} />
                </Box>
            </Container>
        </Box>
    );
}

export default CourseOverview